"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.headers = exports.ALGORITHM_INDEX = exports.SOURCE_KEYS = exports.SPLIT_INTO_FIVE = exports.XOR_ENCRYPT = exports.COL_TRANSPOSITION_ENCODE = exports.TRIPLEDES = exports.RAIL_FENCE_CIPHER = exports.INSER_ONLY_AT_3_WITH_3_CHAR = exports.INSERT_ONLY_AT_3 = exports.INSERT_RANDOM_AT_3 = exports.SPLIT_INTO_FOUR = exports.SPLIT_INTO_THREE = exports.ADD_EXTRA_CHAR = exports.REVERSE = exports.BASE64 = exports.ALGORITHMS = void 0;
exports.ALGORITHMS = {
    "ALGO_ONE": ['BASE64', 'SPLIT_INTO_FOUR', 'REVERSE', 'INSERT_RANDOM_AT_3'],
    "ALGO_TWO": ['BASE64', 'RAIL_FENCE_CIPHER', 'SPLIT_INTO_THREE', 'ADD_EXTRA_CHAR'],
    "ALGO_THREE": ['BASE64', '3DES', 'SPLIT_INTO_FOUR', 'REVERSE'],
    "ALGO_FOUR": ['BASE64', 'COL_TRANSPOSITION_ENCODE', 'SPLIT_INTO_FOUR', 'REVERSE'],
    "ALGO_FIVE": ['BASE64', 'XOR_ENCRYPT', 'SPLIT_INTO_FIVE', 'ADD_EXTRA_CHAR']
};
exports.BASE64 = 'BASE64';
exports.REVERSE = 'REVERSE';
exports.ADD_EXTRA_CHAR = 'ADD_EXTRA_CHAR';
exports.SPLIT_INTO_THREE = 'SPLIT_INTO_THREE';
exports.SPLIT_INTO_FOUR = 'SPLIT_INTO_FOUR';
exports.INSERT_RANDOM_AT_3 = 'INSERT_RANDOM_AT_3';
exports.INSERT_ONLY_AT_3 = 'INSERT_ONLY_AT_3';
exports.INSER_ONLY_AT_3_WITH_3_CHAR = 'INSER_ONLY_AT_3_WITH_3_CHAR';
exports.RAIL_FENCE_CIPHER = 'RAIL_FENCE_CIPHER';
exports.TRIPLEDES = '3DES';
exports.COL_TRANSPOSITION_ENCODE = 'COL_TRANSPOSITION_ENCODE';
exports.XOR_ENCRYPT = 'XOR_ENCRYPT';
exports.SPLIT_INTO_FIVE = 'SPLIT_INTO_FIVE';
exports.SOURCE_KEYS = {
    VALIDATION_KEY: 'validation',
    TRAVELDOC_KEY: 'traveldoc',
    AUTOSEAT_KEY: 'autoseat',
    ADD_ONS_KEY: 'addons',
    SEAT_KEY: 'seat',
    CHECKOUT_KEY: 'checkout',
    CHECKINCHAIN_KEY: 'checkinchain',
};
exports.ALGORITHM_INDEX = 3;
exports.headers = {
    "Content-Type": "application/json",
    channel_hash: ""
};
